export default "__VITE_ASSET__CKUamr8r__"